export default __webpack_public_path__ + "static/media/bg_login.3d0f2648.png";